<template>
  <div class="project-menu-tab">
    <div class="tab-wrapper">
      <div
        v-for="(menu, index) in tabMenus"
        :key="index"
        :class="['tab-menu', { 'active': index == tabIndex }]"
        @click="tabIndex = index"
      >
        {{ $t(`common.projectMenuTabMenus.${menu}`) }}
      </div>
    </div>
    <div class="menu-wrapper">
      <task-lists
        v-if="tabMenus[tabIndex] === 'taskList'"
      />
      <gantt-chart
        v-else-if="tabMenus[tabIndex] === 'ganttChart'"
      />
      <project-chat
        v-else-if="tabMenus[tabIndex] === 'projectChat'"
      />
      <files
        v-else-if="tabMenus[tabIndex] === 'file'"
      />
    </div>
  </div>
</template>

<script>
import Files from '@/components/organisms/projectMenuTab/Files'
import GanttChart from '@/components/organisms/projectMenuTab/GanttChart'
import ProjectChat from '@/components/organisms/projectMenuTab/ProjectChat'
import TaskLists from '@/components/organisms/projectMenuTab/TaskLists'

export default {
  name: 'ProjectMenuTab',
  components: {
    Files,
    GanttChart,
    ProjectChat,
    TaskLists
  },
  props: {
    defaultMenu: {
      type: String,
      default: 'taskList'
    }
  },
  computed: {
    tabMenus: function() {
      return [
        'taskList',
        'ganttChart',
        'projectChat',
        'file'
      ]
    }
  },
  data() {
    return {
      tabIndex: 0
    }
  },
  mounted() {
    const defaultTabIndex = this.tabMenus.indexOf(this.defaultMenu)
    if (defaultTabIndex > 0) {
      this.tabIndex = defaultTabIndex
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.project-menu-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.tab-wrapper {
  display: flex;
  border-bottom: 1px solid $dark-border-color;
  z-index: 1;
  min-height: 36px;
  overflow-x: auto;

  .tab-menu {
    font-size: 13px;
    font-weight: 600;
    color: $light-text-color;
    border-bottom: 4px solid $light-gray-color;
    padding: 15px;
    cursor: pointer;
    word-break: keep-all;

    &:first-child {
      margin-left: 0;
      padding-left: 15px;

      @include mq(md) {
        margin-left: 15px;
      }
    }

    &.active {
      color: $primary-color;
      border-bottom: 4px solid $primary-color;
    }
  }
}

.menu-wrapper {
  height: 100%;
  padding: 20px;
}
</style>
